

























































import Vue from 'vue';
import OldFormatHelper from '../../../../helpers/OldFormatHelper';
import { IBarometerPointsDetails } from '@/common/interfaces/barometer.interface';

interface IRevenueBarometerDataDetails {
  formatHelper: typeof OldFormatHelper;
}

export default Vue.extend({
  data(): IRevenueBarometerDataDetails {
    return {
      formatHelper: OldFormatHelper,
    };
  },
  props: {
    data: {
      required: true,
      type: Object as () => IBarometerPointsDetails,
    },
  },
});
